export const customer = {
  get: 'crm/r/{country}/v1/customers',
  create1: 'customerEndpoint/createCustomer',
  create: 'crm/w/{country}/v1/customers',
  createCallCenter: 'customerEndpoint/createCustomerCallCenter',
  login: 'customerEndpoint/login',
  loginPost: 'auth/r/{country}/v2/login',
  loginGoogle: 'customerEndpoint/loginGoogle',
  loginFacebook: 'customerEndpoint/loginFacebook',
  loginFirebase: 'customerEndpoint/loginFirebase',
  loginSocialPlatforms: 'auth/r/{country}/v1/login/platforms',
  loginBmc: 'crm/r/{country}/v1/customers/login-bmc',
  deleteDevice: 'customerEndpoint/deleteDevice',
  validate: 'crm/r/{country}/v1/customers/registered',
  validateSmsTokenFinal: 'customerEndpoint/getValidationTokenPhoneFinal',
  validateSmsToken: 'auth/w/{country}/v1/register/code',
  validateCodeRegister: 'auth/r/{country}/v1/register/code',
  validateWhatsapp: 'whatsApp/send',
  resetPassword: 'customerEndpoint/resetPassword',
  changePassword: 'crm/w/CO/v1/customers/password',
  changePasswordOtp: 'crm/w/{country}/v1/customer/change-password-otp',
  changePasswordV2: 'customerEndpoint/changePasswordV2',
  update: 'crm/w/{country}/v1/customers',
  interests: 'customerEndpoint/createCustomerInterests',
  getUserOrigin: 'crm/r/{country}/v1/customers/verify',
  getCustomerByPhoneNumberOrDocumentNumber: 'customerEndpoint/getCustomerCallCenter',
  getCustomerByDocumentId: 'crm/v3/customer/search',
  sendCode: 'auth/w/{country}/v1/login/code',
  sendCodeRegisterExpress: 'auth/w/{country}/v2/register/code',
  validateCodeOTP: 'auth/r/{country}/v2/login/code',
  validateCodeOtpRegisterExpress: 'auth/r/{country}/v2/register/code',
  customerOnly: 'customerEndpoint/customerOnly',
  yunoToken: 'customerEndpoint/tokenCreditCard',
  gatewayActive: 'customerEndpoint/gateway',
  verifyCustomer: 'antifraud/v3/verifyCustomer',
  saveNonStockItem: 'crm/v3/customer/nonStockItems',
  getSaveNonStockItem: 'crm/v3/customer',
  removeNonStockItem: 'crm/v3/customer/removeNonStockItems',
  updateUserExpress: 'crm/w/CO/v1/customers/express/update/',
  tokenJwt:{
    create:  'auth/r/{country}/v1/token',
    refresh: 'auth/r/{country}/v1/token/refresh'
  } 
};
